import '../extensions/date.extension';
import '../extensions/array.extension';
import { PageEvent } from '@angular/material/paginator';
import { IPaginatedResult } from '../interfaces/mailing/IPaginatedResult';
import { IS_PRODUCT_SAFETY_PROJECT, IS_TRS_PROJECT } from '../../../current-project';

export function array_move<T>(arr: Array<T>, oldIndex: number, new_index: number): Array<T> {
    if (new_index >= arr.length) {
        let k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(oldIndex, 1)[0]);
    return arr;
}

export function millisecondsToDays(t: number): number {
    const cd = 24 * 60 * 60 * 1000;
    const ch = 60 * 60 * 1000;
    const d = Math.floor(t / cd);
    const h = Math.floor((t - d * cd) / ch);
    const m = Math.round((t - d * cd - h * ch) / 60000);
    const normalizedHours = h + (m === 60 ? 1 : 0);

    // return [d, pad(h), pad(m)].join(':');
    return normalizedHours === 24 ? d + 1 : d;
}

export function distinctArray<T>(object: Array<any>, key?: string): Array<T> {
    return !object
        ? []
        : object
              .sort((a, b) => (key ? String(a[key]).localeCompare(String(b[key])) : String(a).localeCompare(String(b))))
              .filter((e, i, arr) => i === 0 || (key ? arr[i - 1][key] !== e[key] : arr[i - 1] !== e));
}

export const currentDate: Date = new Date().toUTC();
export const currentMonth: number = currentDate.getMonth();
export const currentYear: number = currentDate.getFullYear();
export const currentReportingPeriod: string = IS_TRS_PROJECT
    ? `${currentYear - 1}/${currentYear}`
    : currentMonth > 9
      ? `${currentYear}/${currentYear + 1}`
      : `${currentYear - 1}/${currentYear}`;
export const reportingPeriod = (minus = 0): string | { label: string; showLabel: string } => {
    if (IS_TRS_PROJECT) {
        return {
            label: `${currentYear - 1 - minus}/${currentYear - minus}`,
            showLabel: `${currentYear - minus}`
        };
    }

    if (IS_PRODUCT_SAFETY_PROJECT) {
        return currentMonth > 9
            ? `${currentYear - minus}/${currentYear + 1 - minus}`
            : `${currentYear - 1 - minus}/${currentYear - minus}`;
    }
};

export const beginningDate: Date = IS_TRS_PROJECT ? new Date(currentYear, 6, 15) : new Date(currentYear, 6, 30);

export function compare(a: any, b: any, order?: any[]) {
    if (order ? order.indexOf(a) > order.indexOf(b) : a instanceof String ? a.localeCompare(b) : a > b) {
        return +1;
    }
    if (order ? order.indexOf(a) < order.indexOf(b) : a instanceof String ? a.localeCompare(b) : a < b) {
        return -1;
    }
    return 0;
}

export const disableBackgroundScrolling = () => (document.body.style.overflow = 'hidden');
export const enableBackgroundScrolling = () => (document.body.style.overflow = 'scroll');

export function getPage<T>(pagination: PageEvent, items: Array<T>): IPaginatedResult<T> {
    let itemStartCount;
    let itemEndCount;

    if (pagination) {
        if (!itemStartCount) {
            itemStartCount = pagination.pageIndex * pagination.pageSize;
            itemEndCount = itemStartCount + pagination.pageSize;
        }

        while (itemStartCount > items.length) {
            pagination.pageIndex -= 1;
            itemStartCount = itemStartCount * pagination.pageIndex;
        }
    }

    const limitedItems = pagination?.pageSize != null ? items.slice(itemStartCount, itemEndCount) : items;

    return {
        items: limitedItems,
        hasMore: itemEndCount < items.length,
        page: pagination?.pageIndex ?? 0,
        pageSize: pagination?.pageSize,
        currentItems: limitedItems.length,
        totalItems: items.length
    };
}
